import { useState } from 'react'

import { useWidgetListApi } from '@/common/api/modules/widget'
import { useFirstLoading } from '@/common/api/search'
import { WIDGET_SEARCH_CONDITION_CLEAR, WidgetSearchCondition } from '@/common/app/modules/recommend/widget'
import { tagsPath, widgetNewPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge from '@/components/container/layout/AppTitleBadge'
import WidgetCssModalProvider from '@/components/container/modal/widget/css/WidgetCssModalProvider'
import WidgetDesignModalProvider from '@/components/container/modal/widget/design/WidgetDesignModalProvider'
import WidgetBlock from '@/components/container/modules/recommend/widget/WidgetBlock'
import WidgetSearchConditionField from '@/components/container/modules/recommend/widget/WidgetSearchConditionField'

const WidgetListPage = () => {
  const siteId = useSiteId()
  const [condition, setCondition] = useState<WidgetSearchCondition>(WIDGET_SEARCH_CONDITION_CLEAR)
  const { data, isLoading, mutate } = useWidgetListApi({
    site_id: siteId,
    content_type: condition.contentType || undefined,
    display_logic: condition.displayLogic || undefined
  })

  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <WidgetDesignModalProvider>
      <WidgetCssModalProvider>
        <Main type={MainLayoutType.SMALL} bottomSpace>
          <PageTitle
            title={'レコメンドパーツ一覧'}
            rightNode={
              <>
                <Button link={tagsPath(siteId)} size='large' color={ButtonColor.SECONDARY}>
                  埋め込みコード情報
                </Button>
                <Button link={widgetNewPath(siteId)} size='large' color={ButtonColor.PRIMARY_BRAND}>
                  レコメンドパーツを追加する
                </Button>
              </>
            }
            badgeNode={<AppTitleBadge type='recommend' />}
          />
          <WidgetSearchConditionField condition={condition} setCondition={setCondition} />
          {isFirstLoading ? (
            <PageListLoading />
          ) : data && data.length > 0 ? (
            <Content>
              {data.map((widget) => (
                <WidgetBlock key={widget.id} widget={widget} onRefresh={mutate} />
              ))}
            </Content>
          ) : (
            <Area tableWrap>
              <NoResultGuidance name='レコメンドパーツ' />
            </Area>
          )}
        </Main>
      </WidgetCssModalProvider>
    </WidgetDesignModalProvider>
  )
}

export default WidgetListPage
